import { createMuiTheme } from '@material-ui/core/styles';
import Logo from '../../assets/intilion-logo.svg';

import '../../assets/styles/fonts.css';

// Intilion
export const iOrange = '#ec6622';
export const iLightOrange = '#ed8404'; // Only for gradients!
export const iAnthracite = '#414140';
export const iVeryLightGray = '#e6e6e6';
export const iLightGray = '#7a7a7a';
export const iGray = '#303030';
export const iDarkGray = '#1e1e1e';
export const iBlack = '#140f0f';
export const iRed = '#ff6368';
export const iYellow = '#ffaf59';
export const iGreen = '#69d16c';
export const black = '#000000';
export const white = '#ffffff';

export const dunkelgelb = '#f7cd00';
export const hellgelb = '#fff101';
export const dunkelgrau01 = '#56524b';
export const hellblau01 = '#43a2bd';
export const tuerkis01 = '#007484';
export const dunkelblau01 = '#083142';
export const magenta = '#c60298';
export const dunkelgrau02 = '#7b7972';
export const dunkelgrau03 = '#b1acaa';
export const dunkelgrau04 = '#c5c1bf';
export const dunkelgrau05 = '#d8d5d4';
export const dunkelgrau06 = '#ebeaea';
export const hgGrau = '#f3f3f3';
export const hellblau02 = '#72b9ce';
export const hellblau03 = '#a1d1de';
export const hellblau04 = '#d1e8ef';
export const tuerkis02 = '#4097a3';
export const tuerkis03 = '#80bac2';
export const tuerkis04 = '#c0dde1';
export const dunkelblau02 = '#466571';
export const dunkelblau03 = '#8498a1';
export const dunkelblau04 = '#c2ccd0';

const theme = createMuiTheme({
	companyLogo: Logo,

	breakpoints: {
		values: {
			xs: 0,
			sm: 600,
			md: 960,
			lg: 1280,
			xl: 1920,
		},
	},

	typography: {
		fontFamily: '"Open Sans", Helvetica Neue, sans-serif',
	},

	palette: {
		bscolors: {
			bsYellow: hellgelb,
			bsOcean: tuerkis01,
			bsDarkOcean: tuerkis02,
			bsGolden: dunkelgelb,
			bsDarkblue: dunkelblau01,
			bsDarkblue04: dunkelblau04,
			grey01: dunkelgrau01,
			bspurple: magenta,
			lightBlueGrey: tuerkis04,
			bshellblau01: hellblau01,
		},

		background: {
			default: iDarkGray,
			secondary: iLightGray,
			error: iRed,
			warning: iYellow,
			success: iGreen,
		},

		primary: {
			main: white,
			dark: black,
		},

		secondary: {
			main: hellgelb,
		},

		text: {
			primary: white,
			secondary: iLightGray,
			link: iOrange,
			gradient: `linear-gradient(45deg, ${iOrange} 0%, ${iLightOrange} 100%)`,
		},

		blocks: {
			header: {
				background: black,
				color: white,
				borderColorActiveLink: iOrange,
				backgroundColorDropdown: iGray,
				dropdown: {
					backgroundColor: iGray,
					dividerColor: iLightGray,
					linkColor: white,
					linkColorHover: iOrange,
				},
			},

			footer: {
				background: black,
				borderColor: iOrange,
				color: white,
				linkColor: iOrange,
			},

			cardWrapper: {
				background: iGray,
				color: white,
			},

			table: {
				thead: {
					borderColor: iOrange,
				},
				tbody: {
					borderColor: iVeryLightGray,
					labelColor: iLightGray,
				},
			},

			stickyAppBar: {
				background: iGray,
				color: white,
			},

			breadcrumbs: {
				color: white,
			},

			stepper: {
				number: {
					backgroundColor: iOrange,
					color: white,
				},
				text: {
					color: white,
				},
			},

			graph: {
				overlay: {
					backgroundColor: 'rgba(0, 0, 0, 0.8)',
					backgroundColorActive: iOrange,
				},
				content: {
					backgroundColorCo2: black,
				},
			},

			dashboardSwitch: {
				backgroundColor: iGray,
				color: white,
			},
		},

		button: {
			primary: {
				backgroundColor: iOrange,
				color: white,
			},
			outline: {
				backgroundColor: 'transparent',
				color: white,
				backgroundColorHover: white,
				colorHover: black,
			},
		},

		input: {
			disabled: {
				color: iLightGray,
				borderColor: iLightGray,
			},
		},

		dropzone: {
			borderColor: iDarkGray,
			backgroundImage: `linear-gradient(45deg, ${iOrange} 0%, ${iLightOrange} 100%)`,
			color: white,
			button: {
				backgroundColor: 'rgba(255, 255, 255, 0.1)',
				backgroundColorHover: white,
				colorHover: black,
			},
		},

		progressBar: {
			backgroundColor: iDarkGray,
			progressColor: iOrange,
		},

		title: {
			flexGrow: 1,
		},

		white: {
			main: white,
		},

		switchColors: {
			first: iOrange,
			second: iLightOrange,
			third: iVeryLightGray,
			fourth: iRed,
			fifth: iGreen,
			sixth: iYellow,
		},
	},

	overrides: {
		MuiCssBaseline: {
			'@global': {
				a: {
					color: iOrange,
				},
			},
		},

		MuiPaper: {
			root: {
				backgroundColor: iGray,
			},
		},

		MuiBackdrop: {
			root: {
				backgroundColor: 'rgba(0, 0, 0, 0.8)',
			},
		},

		MuiAppBar: {
			colorPrimary: {
				color: white,
				backgroundColor: iGray,
			},
		},

		MuiDialogTitle: {
			root: {
				'& .MuiIconButton-root': {
					color: white,
				},
			},
		},

		MuiOutlinedInput: {
			root: {
				borderColor: white,
				borderRadius: 5,
				color: white,
			},
			notchedOutline: {
				borderWidth: 2,
				borderColor: white,
			},
		},

		MuiInputAdornment: {
			root: {
				'& .MuiButtonBase-root': {
					color: white,
				},
			},
		},

		MuiInputLabel: {
			shrink: {
				backgroundColor: `${iDarkGray} !important`,
			},
		},

		MuiFormLabel: {
			root: {
				color: white,
			},
		},

		MuiDivider: {
			root: {
				backgroundColor: iLightGray,
			},
		},

		MuiFormControlLabel: {
			root: {
				marginLeft: 0,
				marginRight: 0,
			},
		},

		MuiTabs: {
			indicator: {
				backgroundColor: iOrange,
			},
		},

		MuiTab: {
			root: {
				fontWeight: 'bold',
			},
		},

		MuiAutocomplete: {
			popper: {
				backgroundColor: iDarkGray,
			},
		},

		MuiRadio: {
			root: {
				color: iOrange,
			},
			colorSecondary: {
				color: iOrange,
				'&$checked': {
					color: iOrange,
				},
			},
		},
	},

	spacing: (factor) => `${0.25 * factor}rem`, // (Bootstrap strategy)
});

export default theme;
